(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[768],{

/***/ 60500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-xxl":"1360px","varXxl":"1360px"};

/***/ }),

/***/ 60768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _tk_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60500);
/* harmony import */ var _tk_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tk_css__WEBPACK_IMPORTED_MODULE_1__);


var TKVariables = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TKVariables);


/***/ })

}]);